// Смена имени из кабинета: регрессия после переезда попапа пользователя в
// AccountSettingsModal — поле было в удалённом AccountModal, здесь оно
// восстановлено отдельным компонентом по тому же образцу, что и смена пароля.
import { useId, useState, type FormEvent, type ReactElement } from 'react';
import { useT } from '../i18n';
import { useAuth } from './AuthProvider';
import { updateName } from './api';
import { errorKey } from './errors';
import type { ApiError } from './api';
import styles from './NameChangeForm.module.css';

export function NameChangeForm(): ReactElement {
  const t = useT();
  const ids = useId();
  const { user, applyUser } = useAuth();

  const original = user?.name ?? '';
  const [name, setName] = useState(original);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);
  const [busy, setBusy] = useState(false);

  // Пустое имя — валидный результат (сервер сам обрежет и запишет пустую
  // строку, кнопка аккаунта тогда покажет почту), но пустой запрос без
  // изменений никому не нужен — сравниваем с тем, что реально хранится.
  const unchanged = name.trim() === original;

  async function handleSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    if (unchanged) return;
    setBusy(true);
    setError(null);
    const res = await updateName(name);
    setBusy(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    if (res.value?.user) {
      applyUser(res.value.user);
      setName(res.value.user.name);
    }
    setSaved(true);
  }

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      {error && (
        <p className={styles.error} role="alert">
          {t(errorKey(error))}
        </p>
      )}

      <label className={styles.label} htmlFor={`${ids}-name`}>
        {t('auth.name')}
      </label>
      <input
        id={`${ids}-name`}
        className={styles.control}
        type="text"
        maxLength={80}
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          setSaved(false);
        }}
      />

      {saved && <p className={styles.notice}>{t('account.saved')}</p>}

      <div className={styles.buttonRow}>
        <button type="submit" className={`${styles.btn} ${styles.btnPrimary}`} disabled={busy || unchanged}>
          {t('account.save')}
        </button>
      </div>
    </form>
  );
}
